// Curated list of common Indian salary/savings banks for the "Income Credited To"
// combobox in the loan-cockpit customer-income form.
const INDIAN_BANKS = [
  'HDFC Bank Ltd', 'ICICI Bank Ltd', 'State Bank of India', 'Axis Bank Ltd',
  'Kotak Mahindra Bank Ltd', 'IndusInd Bank Ltd', 'Yes Bank Ltd', 'IDFC First Bank Ltd',
  'Punjab National Bank', 'Bank of Baroda', 'Canara Bank', 'Union Bank of India',
  'Bank of India', 'Central Bank of India', 'Indian Bank', 'Indian Overseas Bank',
  'UCO Bank', 'Punjab & Sind Bank', 'Bank of Maharashtra', 'IDBI Bank Ltd',
  'Federal Bank Ltd', 'South Indian Bank Ltd', 'Karur Vysya Bank Ltd', 'City Union Bank Ltd',
  'Karnataka Bank Ltd', 'DCB Bank Ltd', 'RBL Bank Ltd', 'Bandhan Bank Ltd',
  'Jammu & Kashmir Bank Ltd', 'Tamilnad Mercantile Bank Ltd', 'CSB Bank Ltd',
  'AU Small Finance Bank Ltd', 'Equitas Small Finance Bank Ltd', 'Ujjivan Small Finance Bank Ltd',
  'Standard Chartered Bank', 'Citibank N.A.', 'HSBC Bank', 'Deutsche Bank',
  'DBS Bank India Ltd', 'Bank of America', 'Other',
];

export const getIndianBanks = () => INDIAN_BANKS;

export default INDIAN_BANKS;
